export class SourceType {
  RM = 'RM';
  BROKER = 'Broker';
  BRANCH = 'Branch';
  COLD_CALL = 'Cold call';
  CROSS_BORDER_REF = 'Cross Border Ref';
  CUSTOMER_REF = "Customer's referral";
  ETB = 'ETB';
  EXT_PARTNER_REF = 'Ext. Partner Ref';
  MC = 'MC';
  ME = 'ME';
  REF_BANK = 'Preferred Bank';
  PRIVATE_BANK = 'Private Bank';
  RM_CONTACT = "RM's contact";
  SENIOR_MANAGER = 'Senior Management';
  SME = 'SME';
  WB_IB = 'WB/IB';
  OTHER = 'Others';
}

export type SOURCE_TYPE = keyof SourceType;

// export class LeadStatus {
//     NEW = 'new';
//     PENDING = 'Pending Verified';
//     VERIFIED = 'Verified';
//     APPLICATION_SUBMITTED = 'Application Submitted';
//     ABORT = 'Abort';
// }

export enum LEAD_STATUS_TYPE {
  NEW = 'NEW',
  PENDING_VERIFIED = 'PENDING',
  PENDING_INFO = 'PENDING_INFO',
  VERIFIED = 'VERIFIED',
  APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
  ABORT = 'ABORT',
}

// export type LEAD_STATUS_TYPE = keyof LeadStatus;
